module.exports = __webpack_public_path__ + "img/url.ece19ce6.svg";